import { Reference, ReferenceData } from '@/store/plan/ReferenceData/ReferenceData';
import { AxiosResponse } from 'axios';
import { AxiosInstance } from 'axios';
import { CopyStatuses, ICopyStatuses } from '@/store/plan/CopyStatuses/CopyStatuses';
import { WeeklyDetail } from '@/store/plan/Detail/WeeklyDetail';
import { PlansCommonResponse } from '@/repository/manager/plans/types/PlansCommonResponse';
import { IDetail } from '@/store/plan/Detail/IDeteil';
import { WeekliesRepository } from '@/model/repository/manager/childcare-document/plan/WeekliesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): WeekliesRepository => ({
    async getContents(year: string, month: string, payload: { group_id: string }): Promise<ReferenceData[]> {
    return new Promise<ReferenceData[]>((resolve, reject) => {
      Repository
        .get(`${resource}/contents/year/${year}/month/${month}`, { params: payload })
        .then((res: AxiosResponse<PlansCommonResponse<Reference[]>>) => {
          resolve(res.data.data.map((it: Reference) => new ReferenceData(it.content, it.display_date)));
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          reject({ error, status });
        });
    });
  },

  async getStatuses(year: string, month: string, group_id: string, use_db_replica: boolean): Promise<CopyStatuses> {
    return new Promise<CopyStatuses>((resolve, reject) => {
      Repository
        .get(`${resource}/statuses/year/${year}/month/${month}`, {
          params: { group_id, use_db_replica },
        })
        .then((res: AxiosResponse<PlansCommonResponse<ICopyStatuses>>) => {
          resolve(new CopyStatuses(res.data.data));
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          reject({ error, status });
        });
    });
  },

  getDetail(
    year: string,
    month: string,
    week: string,
    group_id: string,
    use_db_replica: boolean
  ): Promise<WeeklyDetail> {
    return new Promise<WeeklyDetail>((resolve, reject) => {
        Repository
        .get(`${resource}/year/${year}/month/${month}/week/${week}`, {
          params: { group_id, use_db_replica },
        })
        .then((response: AxiosResponse<PlansCommonResponse<IDetail>>) => {
          const res = response.data.data;
          resolve(
            new WeeklyDetail(
              res.id,
              res.kind,
              res.title,
              res.content,
              res.display_date,
              res.open_datetime,
              res.permission_id,
              res.file_url,
              res.update_datetime,
              res.topic_relations
            )
          );
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          reject({ error, status });
        });
    });
  }
  });
